var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkflowIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#171717",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13C14.567 13 13 14.567 13 16.5C13 18.433 14.567 20 16.5 20C18.433 20 20 18.433 20 16.5C20 14.567 18.433 13 16.5 13Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1254 14.7943C26.426 14.5093 26.4386 14.0346 26.1536 13.734C25.8686 13.4334 25.3939 13.4208 25.0933 13.7057L22.984 15.7057C22.8371 15.845 22.7528 16.0377 22.7501 16.24C22.7474 16.4424 22.8266 16.6372 22.9697 16.7803L24.9697 18.7803C25.2626 19.0732 25.7374 19.0732 26.0303 18.7803C26.3232 18.4874 26.3232 18.0126 26.0303 17.7197L25.3107 17H29.25C29.3881 17 29.5 17.1119 29.5 17.25V26.75C29.5 26.8881 29.3881 27 29.25 27H23.75C23.3358 27 23 27.3358 23 27.75C23 28.1642 23.3358 28.5 23.75 28.5H29.25C30.2165 28.5 31 27.7165 31 26.75V17.25C31 16.2835 30.2165 15.5 29.25 15.5H25.3811L26.1254 14.7943Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C14.567 24 13 25.567 13 27.5C13 29.433 14.567 31 16.5 31C18.433 31 20 29.433 20 27.5C20 25.567 18.433 24 16.5 24Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIconActive);
export default __webpack_public_path__ + "static/media/workflow-icon-active.c0308848ac47b20f9a44617dc6e1cc51.svg";
export { ForwardRef as ReactComponent };